import { PrimaryButton } from '@/app/components/PrimaryButton'
import { WEBSITE_LINKS } from '@/app/lib/constants'
import { DocumentReferenceType } from '@/types/document-reference'
import { yupResolver } from '@hookform/resolvers/yup'
import { useTranslations } from 'next-intl'
import Link from 'next/link'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { usePartnerInfo } from '../context/PartnerInfoContext'

type FormValues = {
  email: string
}

export function Newsletter() {
  const t = useTranslations('Newsletter')
  const {
    partnerInfo: { documentType },
  } = usePartnerInfo()

  const FORM_SCHEMA = yup.object({
    email: yup
      .string()
      .email(t('enter_valid_email_address'))
      .required(t('enter_your_email_address')),
  })

  const {
    register,
    handleSubmit,
    setError,
    formState: { isSubmitting, isSubmitSuccessful, errors },
  } = useForm<FormValues>({
    resolver: yupResolver(FORM_SCHEMA),
  })

  const onSubmit = async (data: FormValues) => {
    const urlEncodedData = new URLSearchParams({
      name: 'Subscribe Newsletter',
      pageId: '66dee17afb7d24e2db8c9edc',
      elementId: '3a9c3da8-35d9-d26a-b1a6-a52b006f7884',
      domain: 'mydra-companies-tempalte.webflow.io',
      source: window.location.href,
      test: process.env.NODE_ENV === 'production' ? 'false' : 'true',
      'fields[Email%209]': data.email,
      dolphin: 'false',
    }).toString()

    try {
      const response = await window.fetch(
        'https://webflow.com/api/v1/form/66754248e245f7d666fc34a1',
        {
          method: 'POST',
          body: urlEncodedData,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
        }
      )

      if (!response.ok) {
        const error = new Error('Failed to subscribe')
        error.cause = response
        throw error
      }
    } catch (error) {
      let message = 'Failed to subscribe'
      try {
        const errorResponse = await error.cause.json()
        message = errorResponse.msg
      } catch (err) {
        // Ignore
      }

      setError('root.serverError', { message })
    }
  }

  return (
    <section
      className={`px-2 md:px-8 bg-mydra-black Newsletter ${
        documentType === DocumentReferenceType.EducationProvider
          ? 'bg-transparent'
          : ''
      }`}
    >
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex overflow-hidden flex-col gap-4 px-3 py-6 bg-right-bottom bg-cover rounded-xl md:gap-6 md:px-20 md:py-12 md:pb-8 bg-newsletter text-mydra-white"
      >
        <div>
          <h2 className="!text-sm font-sans md:text-lg font-regular text-center">
            {t('headline')}
          </h2>
          <p className="text-xl text-center md:text-4xl font-title">
            {t('description')}
          </p>
        </div>
        <div className="px-4 md:px-0 w-full md:max-w-[495px] md:mx-auto">
          {isSubmitSuccessful ? (
            <p className="text-sm text-center md:text-base font-title">
              {t('thank_you_for_subscribing')}
            </p>
          ) : (
            <div className="flex overflow-hidden gap-2 p-1 w-full rounded-xl bg-mydra-white md:p-2">
              <input
                {...register('email')}
                className="flex-1 px-4 py-2 w-auto min-w-0 max-w-full text-xs border-none appearance-none outline-none placeholder:text-mydra-black md:text-base text-mydra-black focus:ring-0"
                type="email"
                placeholder={t('enter_your_email_address')}
              />
              <PrimaryButton
                disabled={isSubmitting}
                small
                className="text-xs shrink-0 md:text-sm"
              >
                {isSubmitting ? t('subscribing') : t('subscribe_now')}
              </PrimaryButton>
            </div>
          )}
        </div>
        {(errors.root?.serverError || errors.email) && (
          <p className="self-center p-1 text-xs text-center bg-red-500 rounded-lg md:text-base text-mydra-white">
            {errors.root?.serverError?.message || errors.email?.message}
          </p>
        )}
        <p className="text-center text-xxs md:text-xs font-title">
          {t.rich('terms_and_conditions', {
            Link: (chunks) => (
              <Link
                href={WEBSITE_LINKS.termsAndConditions}
                className="text-mydra-black"
                target="_blank"
              >
                {chunks}
              </Link>
            ),
          })}
        </p>
      </form>
    </section>
  )
}

